<template>
  <section class="mb-4">
    <section-title id="carers">{{
      $t("team-page-home-care-workers-title")
    }}</section-title>
    <div>
      <section>
        <div class="row">
          <div class="col-lg-12">
            <b-card class="mb-3 shadow">{{
              $t("team-page-home-care-workers-description")
            }}</b-card>
          </div>
        </div>
      </section>
      <div class="row">
        <div v-if="loading">
          <b-card class="m-3 shadow">
            <b-media class="text-center">
              <spinner height="128" width="128"></spinner>
            </b-media>
          </b-card>
        </div>

        <div
          class="col-md-6 col-lg-4"
          v-for="(intervenant, i) in intervenants"
          :key="i"
        >
          <b-card class="mb-3 shadow">
            <div class="text-center">
              <b-img
                :src="imgSrc + intervenant.pkAdv + '.jpg'"
                @error.prevent.once="loadAvatar(intervenant, $event)"
                width="128"
                height="128"
                class="rounded-circle mb-3"
                alt="Mélanie Ahouba"
              />
              <h3 class="h4 mb-1">{{ intervenant.fullName }}</h3>
            </div>
            <div>
              <hr />
              <svgicon icon="clock" color="#DA83B1" class="mr-1"></svgicon>
              <small class="text-muted text-uppercase">{{
                $t("team-page-home-care-next-passage")
              }}</small>
              <br />
              <!-- <strong>Aucun passage n'est planifié.</strong> -->
              <strong
                v-if="
                  intervenant.nextInterventionStart !== null &&
                    intervenant.nextInterventionStart !== ''
                "
              >
                <!-- Aujourd'hui, de 18h00 à 20h00 -->

                <!-- {{ moment(intervenant.nextInterventionStart, 'DD/MM/YYYY hh:mm:ss').fromNow() }} -->
                {{
                  moment(intervenant.nextInterventionStart).format(
                    "[Le] DD/MM/YYYY [de] HH[h]mm"
                  )
                }}
                {{
                  moment(intervenant.nextInterventionEnd).format("[à] HH[h]mm")
                }}
              </strong>
              <strong v-else>{{
                $t("team-page-home-care-no-missions")
              }}</strong>
            </div>
          </b-card>
        </div>
        <div v-if="intervenants.length == 0 && !loading && !error">
          <b-card class="m-3 shadow">
            <b-media>{{ $t("team-page-home-care-workers-no-data") }}</b-media>
          </b-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionTitle from "../../SectionTitle.vue";
import fallbackToAvatar from "../../Mixins/fallbackToAvatar.js";
import Spinner from "../../Helpers/Spinner/Spinner.vue";
import { mapState, mapGetters, mapActions } from "vuex";

var moment = require("moment");

export default {
  components: {
    SectionTitle,
    Spinner
  },
  data() {
    return {
      moment: moment,
      intervenants: [],
      loading: true,
      error: false
    };
  },
  mixins: [fallbackToAvatar],
  created() {
    this.load();
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("intervenant", ["allData", "dataError"])
  },
  watch: {
    allData(newData) {
      this.intervenants = newData;
      this.loading = false;
    },
    dataError() {
      this.error = true;
      this.loading = false;
    }
  },
  methods: {
    ...mapActions("intervenant", ["loadIntervenants"]),
    load() {
      if (this.allData) {
        this.intervenants = this.allData;
        this.loading = false;
      } else if (this.user.isPioAgency) {
        const data = {
          start: moment()
            .startOf("month")
            .subtract(2, "months")
            .valueOf(),
          end: moment()
            .add(2, "months")
            .valueOf()
        };
        this.loadIntervenants(data);
      } else {
        this.loadIntervenants();
      }
    }
  }
};
</script>
